import { render, staticRenderFns } from "./OrdersStatusChange.vue?vue&type=template&id=3bb80f2e"
import script from "./OrdersStatusChange.vue?vue&type=script&lang=js"
export * from "./OrdersStatusChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports